const RESPONSIVE_BREAKPOINTS = {
  MOBILE_MIN_WIDTH: 0,
  MOBILE_MAX_WIDTH: 576,
  TABLET_MIN_WIDTH: 577,
  TABLET_MAX_WIDTH: 1024,
  DESKTOP_MIN_WIDTH: 1025,
};

module.exports = RESPONSIVE_BREAKPOINTS;
